﻿import {$, $$, hide, postDataJson, show} from "@/Utils"
import { ResponseMessage } from "@/interfaces"
import { DataAttributes } from "@/enums";

export function initContactInfoFields() {

    $$(".input-field__input-container.inline .change").forEach(i => {
        i.addDataBoundEventListener("click", () => {
            const parent = i.parentElement;
            const cancel = parent.querySelector(".cancel-change") as HTMLElement;
            const readonly = parent.querySelector(".read-only") as HTMLElement;
            const input = parent.querySelector("input");
            const change = i;
            const lastName = input.getAttribute(DataAttributes.NameChange);
            const secureLoginText = parent.querySelector(".name-change") as HTMLElement;

            change.style.display = "none";
            cancel.style.display = "inline";

            if (lastName) {
                show(secureLoginText);
            }
            else {
                readonly.style.display = "none";
                input.type = "text";
            }

            parent.classList.remove("inline");
        });
    });

    $$(".input-field__input-container.inline .cancel-change").forEach(i => {
        i.addDataBoundEventListener("click", () => {
            const parent = i.parentElement;
            const change = parent.querySelector(".change") as HTMLElement;
            const readonly = parent.querySelector(".read-only") as HTMLElement;
            const input = parent.querySelector("input");
            const email = input.getAttribute(DataAttributes.Email);
            const firstname = input.getAttribute(DataAttributes.Firstname);
            const lastname = input.getAttribute(DataAttributes.Lastname);
            const nameChange = input.getAttribute(DataAttributes.NameChange);
            const cancel = i;
            const errorMsg = parent.querySelector(".field-validation-error") as HTMLElement;
            const secureLoginText = parent.querySelector(".name-change") as HTMLElement;

            change.style.display = "";
            cancel.style.display = "";
            readonly.style.display = "";

            parent.classList.add("inline");

            if (nameChange) {
                hide(secureLoginText)
            }

            if (errorMsg) {
                errorMsg.classList.replace("field-validation-error", "field-validation-valid");
            }

            if (email) {
                input.type = "hidden";
                input.value = email;
                input.classList.remove("input-validation-error");
            }

            if (firstname) {
                input.type = "hidden";
                input.value = firstname;
                input.classList.remove("input-validation-error");
            }

            if (lastname) {
                input.type = "hidden";
                input.value = lastname;
                input.classList.remove("input-validation-error");
            }
        });
    });

    const resetEmailInput = () => {
        const emailInput = $(`[${DataAttributes.Email}]`) as HTMLInputElement;
        emailInput.value = emailInput.getAttribute(DataAttributes.Email);
    }

    $(".button-change-email")?.addEventListener("click",
        (e) => {
            const target = e.currentTarget as HTMLElement;
            const newEmail = target.getAttribute("data-new-email");
            const url = window.config.accountEndpoints.changeEmailUrl;
            postDataJson(url, newEmail, (d: ResponseMessage) => {
                const alert = $(".alert--success") as HTMLElement;
                if (!alert) return;

                if (!d.ok) {
                    alert.classList.replace("alert--success", "alert--danger");
                }

                const alertText = alert.querySelector(".alert__text") as HTMLElement;
                alertText.innerText = d.message;

                const modal = target.closest(".modal--active");
                modal.classList.remove("modal--active");

                resetEmailInput();
            });
        });

    $(".button-dont-change-email")?.addEventListener("click", resetEmailInput);
}